var map = {
	"./heroImg.svg": 9395,
	"./icons/bootstrap.svg": 8983,
	"./icons/css3.svg": 7455,
	"./icons/figma.svg": 2005,
	"./icons/htm5.svg": 8621,
	"./icons/html5.svg": 9585,
	"./icons/js.svg": 4674,
	"./icons/nextjs.svg": 6545,
	"./icons/plus.svg": 4491,
	"./icons/reactjs.svg": 3269,
	"./icons/subtract.svg": 5503,
	"./icons/tailwind.svg": 7571,
	"./icons/vue.svg": 2557,
	"./logo.png": 3153,
	"./portfolio": 8695,
	"./portfolio.json": 8695,
	"./profileImage.png": 7622,
	"./profileImage.webp": 7615,
	"./profilePic.png": 8565,
	"./profilePic.webp": 4150
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;